import type { ToastProps } from 'baseui/toast'

// AI-121 (R5): baseui's Toast (which @thanx/uikit Notification wraps) hardcodes
// role="alert" on its Body — assertive, which WCAG 4.1.3 reserves for errors.
// A successful-save confirmation should be POLITE, so screen readers announce it
// without interrupting. baseui spreads `overrides.Body.props` AFTER its own
// `role: 'alert'`, so these props win: role="status" + aria-live="polite".
// Shared by the Settings panes' success Notification AND the agent-tuning modal
// host's post-save confirmation (the error Notification keeps the default
// assertive role="alert", which is correct for errors).
export const successNotificationOverrides: ToastProps['overrides'] = {
  Body: {
    props: {
      role: 'status',
      'aria-live': 'polite',
    },
  },
}
